export const getHeaders = (translations) => [
	'No.',
	translations.username,
	translations.confirmed_orders,
	translations.calls,
];
